export default __webpack_public_path__ + "static/media/sharpspringPortalLogo.330bd3a4.svg";